(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.header = {
    attach: function (context, settings) {
      $('.main-header', context).once('mainHeader').each(function () {
        // Scroll
        var lastScrollTop = 0;
        $(window).scroll(function () {
          if ($(window).scrollTop() > 30) {
            $('.main-header').addClass('scrolled');
          } else {
            $('.main-header').removeClass('scrolled');
          }
          var st = $(this).scrollTop();
          if (st > lastScrollTop) {
            $('.main-header').removeClass('scrollUp').addClass('scrollDown');
          } else {
            $('.main-header').removeClass('scrollDown').addClass('scrollUp');
          }
          lastScrollTop = st;
        });

        // Burger
        $(document).on('click', ".main-header .toggle-menu", function () {
          $(this).toggleClass('open');
          $(this).attr("aria-expanded") == "true" ? $(this).attr("aria-expanded", "false") : $(this).attr("aria-expanded", "true");

          $('.main-nav').removeClass('open-lvl1').removeClass('open-lvl2');
          $(".main-nav .menu-wrapper .menu-item--expanded").removeClass('open');

          $('body').toggleClass('nav-open');
        });

        //languages
        $('.main-header .language-switcher-language-url').each(function () {
          var that = $(this);
          var activeLang = that.find('li.is-active a').text();

          // create span with active lang
          that.parents(".languages").prepend('<span class="label">' + activeLang + '</span>');

          // hide  active lang in ul
          that.find('li.is-active').remove();
        });
      });

      $('.main-nav', context).once('mainNav').each(function () {
        // Active
        $(".main-nav .menu-wrapper ul > li > a.is-active").parent("li").addClass("menu-item--active-trail");

        // Expanded
        $(".main-nav .menu-wrapper").each(function () {
          $(this).find(".menu-item--expanded > .menu").before('<button type="button" class="toggle-lvl" aria-expanded="false"><svg viewBox="0 0 4 6"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#angle-right"></use></svg><span class="sr-only">' + Drupal.t("Expand child") + '</span></button');

          if ($(this).find("ul ul").length) {
            if (!$(".menu-back").length) {
              $(".main-nav").prepend('<button type="button" class="menu-back" aria-expanded="false"><svg viewBox="0 0 4 6"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#angle-left"></use></svg><span class="sr-only">' + Drupal.t("Back") + '</span></button');
            }
          }
        });

        // Back
        $(document).on('click', ".main-nav .menu-back", function () {
          if ($(".main-nav").hasClass("open-lvl2")) {
            $(".main-nav").removeClass('open-lvl2');
            $(".main-nav .menu-wrapper ul > li > ul > li.menu-item--expanded").removeClass('open');
          } else {
            $(".main-nav").removeClass('open-lvl1');
            $(".main-nav .menu-wrapper ul > li.menu-item--expanded").removeClass('open');
          }
        });

        // Open
        $(document).on('click', ".main-nav .menu-wrapper ul > li.menu-item--expanded > span, .main-nav .menu-wrapper ul > li.menu-item--expanded > .toggle-lvl", function (e) {
          e.preventDefault();

          $(".main-nav .menu-wrapper .menu-item--expanded").removeClass('open');
          $(this).closest("li").addClass('open');
          $(this).closest("li").parents("li").addClass('open');

          if (!$(".main-nav").hasClass("open-lvl1")) {
            $(".main-nav").addClass('open-lvl1');
          } else {
            $(".main-nav").addClass('open-lvl2');
          }
        });
        $(document).on('click', function (e) {
          var $clicked = $(e.target);

          if (!($clicked.parents().hasClass("menu-item--expanded") || $clicked.hasClass("menu-item--expanded") || $clicked.parents().hasClass("menu-back") || $clicked.hasClass("menu-back"))) {
            $(".main-nav .menu-wrapper .menu-item--expanded").removeClass('open');
          }
        });
        $(window).scroll(function () {
          if ($(window).scrollTop() > 30) {
            $(".main-nav .menu-wrapper .menu-item--expanded").removeClass('open');
          }
        });

        // Hover
        $(".main-nav .menu-wrapper > ul > li").on("mouseenter", function () {
          $(".main-nav .menu-wrapper > ul > li").removeClass('hover');
          $(this).addClass('hover');
        });
        $(".main-header").on("mouseleave", function () {
          $(".main-nav .menu-wrapper > ul > li").removeClass('hover');
        });
      });
    }
  }
})(jQuery, Drupal, drupalSettings);
